import { render, staticRenderFns } from "./DatadictForTest.vue?vue&type=template&id=a6f3741e&scoped=true"
import script from "./DatadictForTest.vue?vue&type=script&lang=js"
export * from "./DatadictForTest.vue?vue&type=script&lang=js"
import style0 from "./DatadictForTest.vue?vue&type=style&index=0&id=a6f3741e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f3741e",
  null
  
)

export default component.exports